module.exports = __webpack_public_path__ + "img/ai_tag_icon.42087562.svg";